import { render } from "./SidebarItemLink.vue?vue&type=template&id=6d552c7e"
import script from "./SidebarItemLink.vue?vue&type=script&lang=js"
export * from "./SidebarItemLink.vue?vue&type=script&lang=js"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__